
<template>
  <div>
    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'1-7'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>시스템 관리 - 포인트 로그</p>
          <div class="Admin_PageHeader_btn">
          </div>
        </div>

        <div class="Admin_PageInner">
          <div class="Admin_PageInfo">
          </div>
          <div ref="table"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import {TabulatorFull as Tabulator} from 'tabulator-tables'
import {
  get_point_log_all,
  get_session_admin
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminManagement',
  components: {
    AdminHeader,
    AdminFooter
  },
  data () {
    return {
      tabulator: null
    }
  },
  mounted () {
    get_session_admin().then(result => {
      get_point_log_all(result.admin_number).then(result_data => {
        this.tabulator = new Tabulator(this.$refs.table, {
          data: result_data,
          layout: 'fitData',
          pagination: 'local',
          paginationSize: 100,
          paginationButtonCount: 5,
          columns: [
            {title: 'ID', field: 'point_log_ID', headerSort: false},
            {title: '일자', field: 'point_log_registe', headerSort: false},
            {title: '고객고유번호', field: 'customer_ID_use_point_log', headerSort: false},
            {title: '고객구분', field: 'customer_join_division', headerSort: false},
            {title: '고객명', field: 'customer_name', headerSort: false},
            {title: '내용', field: 'point_log_content', headerSort: false},
            {title: '구분', field: 'point_log_status_name', headerSort: false},
            {
              title: '포인트',
              field: 'point_log_point',
              headerSort: false,
              hozAlign: 'right',
              formatter: function (cell) {
                let value = cell.getValue()
                return value.toLocaleString() + 'P'
              }
            }
          ]
        })
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/SystemManagement/AdminPointLogManagement.vue